<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center"><img alt="" src="OEBPS/images/vi-1.jpg"/></p>
<p class="nonindent">To Zaneta and Zelie, and to all the talented, hardworking people at Barcelona</p>
<p class="center"><img alt="" src="OEBPS/images/vii-1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740790683_epub_ded_r1.vue?193f0f77